import { render } from "./scoping-page.vue?vue&type=template&id=61261d60"
import script from "./scoping-page.vue?vue&type=script&lang=js"
export * from "./scoping-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__